export const paString = {
    slug(slug, camelize) {
        camelize = camelize || true;

        slug = slug.trim();
        slug = slug.replace('Ã¶', 'o').replace('Ã¼', 'u');
        slug = slug.replace(/[^A-Z0-9]+/ig, ' ');

        if (camelize) {
            slug = paString.camelize(slug);
        } else {
            slug = slug.replace(/[ ]+/ig, '-');
            slug = slug.toLowerCase();
        }

        return slug;
    },
    htmlEntities(str) {
        return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    },
    camelize(str) {
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
            return index == 0 ? letter.toLowerCase() : letter.toUpperCase();
        }).replace(/\s+/g, '');
    }
};


// WEBPACK FOOTER //
// ./src/js/framework/helpers/paString.js